import { ApiResponse, TokenData } from '../models';
import * as http from './http';
import ApiService from './service';

export class AuthService extends ApiService {
  static loginUrl = '/api/auth/login';
  static azureLoginUrl = '/api/auth/azure-ad-login';
  static passwordUrl='/api/auth/reset-password';
  static updatePasswordUrl='/api/auth/update-password';
  static changePasswordUrl='/api/auth/change-password';
  static resendOtp='/api/auth/resend-otp';


  public async login(credentials: { username: string; password: string }) {
    const url = `${this.apiDomain}${AuthService.loginUrl}`;
    const data = {
      username: credentials.username,
      password: credentials.password,
    };
    const response = await http.post<ApiResponse<TokenData>>(url, data);
    return response.data;
  }

 

  public async forgotPassword(body: { email: string,  requestType: string}) {
    const url = `${this.apiDomain}${AuthService.passwordUrl}`;
    const data = {
    email:body.email,
    requestType:'resetPassword'
    };
    const response = await http.post<ApiResponse<any>>(url, data);
    return response.data;
  }

  public async resendOtp(body: {requestType:string, requestId:string }) {
    const url = `${this.apiDomain}${AuthService.resendOtp}`;
    const data = {
      requestType:'resetPassword',
      requestId:body.requestId
  
    };
    const response = await http.post<ApiResponse<any>>(url, data);
    return response.data;
  }

  public async setPassword(body: {otp: string, password: string, requestType:string, requestId:string }) {
    const url = `${this.apiDomain}${AuthService.updatePasswordUrl}`;
    const data = {
      otp: body.otp,
      password: body.password,
      requestType:'resetPassword',
      requestId:body.requestId
      
    
    };
    const response = await http.post<ApiResponse<any>>(url, data);
    return response.data;
  }
  
  public async changePassword(body: {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
  }, userId: string) {
    const url = `${this.apiDomain}${AuthService.changePasswordUrl}`;
    const data = {
      currentPassword: body.currentPassword,
      newPassword: body.newPassword,
    };
    const response = await http.put<ApiResponse<any>>(url, data, this.store);
    return response.data;
  }

  public async azureAdlogin(credentials: { accessToken: string }) {
    const url = `${this.apiDomain}${AuthService.azureLoginUrl}`;
    const response = await http.post<ApiResponse<TokenData>>(url, credentials);
    return response.data;
  }
  public async getFirebaseToken() {
    const url = `${this.apiDomain}/notification/register-client`;
    const response = await http.post<ApiResponse<TokenData>>(
      url,
      {},
      this.store
    );
    return response.data;
  }
}
